import { createTheme, responsiveFontSizes, alpha } from '@mui/material';
import { grey } from '@mui/material/colors';
import { deepmerge } from '@mui/utils';

var buildThemeWithLegacyOptions = function (existingThemeOptions) {
    // In order to remain faithful to the old MUI4 visual, we must define certain options in the theme :
    var mui4To5GlobalThemeAdaptations = {
        // see: https://mui.com/guides/migration-v4/#button
        palette: {
            "default": {
                main: grey[300],
                dark: grey[400]
            }
        },
        components: {
            MuiCssBaseline: {
                // see: https://mui.com/guides/migration-v4/#cssbaseline
                styleOverrides: {
                    body: {
                        fontSize: "0.875rem",
                        letterSpacing: "0.01071em"
                    }
                }
            }
        }
    };
    var mui4To5ThemeAdaptationsForButton = function (theme) {
        return {
            components: {
                // see: https://mui.com/guides/migration-v4/#button
                MuiButton: {
                    variants: [
                        {
                            props: { variant: "contained", color: "default" },
                            style: {
                                color: theme.palette.getContrastText(theme.palette.grey[300])
                            }
                        },
                        {
                            props: { variant: "outlined", color: "default" },
                            style: {
                                color: theme.palette.text.primary,
                                borderColor: theme.palette.mode === "light"
                                    ? "rgba(0, 0, 0, 0.23)"
                                    : "rgba(255, 255, 255, 0.23)",
                                "&.Mui-disabled": {
                                    border: "1px solid ".concat(theme.palette.action.disabledBackground)
                                },
                                "&:hover": {
                                    borderColor: theme.palette.mode === "light"
                                        ? "rgba(0, 0, 0, 0.23)"
                                        : "rgba(255, 255, 255, 0.23)",
                                    backgroundColor: alpha(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                                }
                            }
                        },
                        {
                            props: { color: "default", variant: "text" },
                            style: {
                                color: theme.palette.text.primary,
                                "&:hover": {
                                    backgroundColor: alpha(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                                }
                            }
                        },
                    ]
                },
                // Here we apply the old color that was used on MUI4 on the selected elements of menuitem
                // see: https://mui.com/guides/migration-v4/#menuitem
                MuiMenuItem: {
                    styleOverrides: {
                        root: {
                            "&.Mui-selected": {
                                backgroundColor: "rgba(0,0,0,0.08)"
                            },
                            "&.Mui-selected:hover": {
                                backgroundColor: theme.palette.common.white
                            },
                            "&.Mui-selected:focus": {
                                backgroundColor: "rgba(0,0,0,0.08)"
                            }
                        }
                    }
                }
            }
        };
    };
    var fontAwesomeOverride = function () {
        return {
            components: {
                MuiIcon: {
                    styleOverrides: {
                        root: {
                            // overrides to no longer have font awesome icons truncated by the width/height of the MuiIcon component :
                            "&.fas": {
                                width: "auto!important",
                                height: "auto!important"
                            }
                        }
                    }
                }
            }
        };
    };
    var theme = createTheme(deepmerge(mui4To5GlobalThemeAdaptations, existingThemeOptions));
    return responsiveFontSizes(createTheme(theme, mui4To5ThemeAdaptationsForButton(theme), fontAwesomeOverride()));
};

export { buildThemeWithLegacyOptions };
//# sourceMappingURL=index.js.map
